export const contactTypeOptions = [
  { label: "Email", value: "Email" },
  { label: "Phone", value: "Phone" },
  { label: "Mobile", value: "Mobile" },
  { label: "Fax", value: "Fax" },
  { label: "Whatsapp", value: "Whatsapp" },
  { label: "Website", value: "Website" },
  { label: "Other", value: "Other" },
];
